export default "__VITE_ASSET__BBIg5Cl5__"